import React, { PropTypes } from 'react';
import LightBox from '../Common/LightBox';

export default class UsuarioItem extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			x: 0, y: 0, 
			isFilesOpen: false, 
			isMapOpen: false, 
			isDetailsOpen: false, 
			locations: {}, 
			files: [],
			details: {} 
		};
	}UsuarioItem

	getStyle(width = 400, height = 400) {
		const top = window.innerHeight < this.state.y + height ? (this.state.y - height) : this.state.y;
		const left = window.innerWidth < this.state.x + width ? (this.state.x - width) : this.state.x;
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { 
				left: `${left}px`,
				top: `${top}px`, 
				height: `${height}px`,
				width: `${width}px`,
				overflowY: "auto", 
				overflowX: "hidden"
			}
		};
	}

	handleDetailsClick(e) {
		const { clientX, clientY } = e;
		this.setState({isDetailsOpen: true, x: clientX, y: clientY});
		// this.props.getDocumentDetails(this.props, callback);
	}

	setFakeJson(infos) {
		const {id, projeto, nome, sobrenome, email, username, grupos} = infos;
		const {mariana, brumadinho} = projeto;
	
		let grps = [];
		
		for ( let i =0; i < (grupos.length); i++) {
			grps.push(grupos[i].name + " ");
		}
		let fakeJson = {
			id: id,
			nome: nome,
			sobrenome: sobrenome,
			email: email,
			mariana: mariana,
			brumadinho: brumadinho,
			username: username,
			password: "",
			confirmpassword: "",
			selectedGroups: grps
		};
		return (<div className="user-field" id="userInfosCopy"> 
			<span className="user-fa">
				<i className="fas fa-times pointer" 
				onClick={() => this.setState({isDetailsOpen: false})} 
				data-tip="Remover Camada" />
			</span>
			<span style={{ color: "#2F0459" }}>
				Dados: &#123;
			</span>
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">id:</span> {fakeJson.id},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">nome:</span> {fakeJson.nome},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">sobrenome:</span> {fakeJson.sobrenome},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">e-mail:</span> {fakeJson.email},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">username:</span> {fakeJson.username},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">projeto:
			</span>{fakeJson.mariana ? ' mariana' : ''}{fakeJson.brumadinho ? ' brumadinho' : ''},
			<br></br>
			&nbsp;&nbsp;<span className="user-fakeJson">grupos:</span> {grps}
			<br></br>
			<span style={{ color: "#2F0459" }}>
			&#125;
			</span>
			<br></br>
		</div>);
	
	}
	render () {
		const { nome, sobrenome, username, email, projeto } = this.props;			
		let userProjectClass= "";
		if (projeto.brumadinho && projeto.mariana) {
			userProjectClass = "user-both";
		} else if (projeto.brumadinho) {
			userProjectClass = "user-brumadinho";
		} else if (projeto.mariana) {
			userProjectClass = "user-mariana";
		}
		return (			
			<div className="document-container">
				<div className={`document-card cs-card user-item`}>	
									
					<div className="document-center" >
						<div className={userProjectClass}></div>
						<div className=" col-md-3 user-nome">
							<div className="user-txt">
								{nome + " " + sobrenome}
							</div>
						</div>
						<div className="col-md-3 user-username">
							<div className="user-txt">
								{username}
							</div>
						</div>
						<div className="col-md-3 user-email">
							<div className="user-txt">
								{email}
							</div>
						</div>
					</div>
					<div className="document-right">
						<div className="document-actions actions-users">
							<div className="user-icons" >
								<i 
									className="fa fa-eye pointer hoverable" 
									data-tip="Mais detalhes" 
									onClick={this.handleDetailsClick.bind(this)}
								/>								
								&nbsp;&nbsp;
								<i 
									className="fa fa-edit pointer hoverable" 
									data-tip="Editar Informações" 
									onClick={() => this.props.redirect(this.props)} 
								/>
								{/* &nbsp;&nbsp;
								<i 
									className="far fa-trash-alt hoverable" 
									data-tip="Editar Informações" 
									onClick={() => this.props.deleteUser(this.props)} 
								/> */}
								{/*removido devido aos problemas de relacionamento*/}
							</div>							
						</div>
						<LightBox						
						isOpen={this.state.isDetailsOpen}						 
						onClose={() => this.setState({isDetailsOpen: false})}
						style={this.getStyle(250, 275)}>
							{this.setFakeJson(this.props)}
						</LightBox>
					</div>
				</div>						
			</div>);
	}
}

UsuarioItem.propTypes = {
	id: PropTypes.number.isRequired,
	index: PropTypes.number.isRequired,
	nome: PropTypes.string.isRequired,
	sobrenome: PropTypes.string.isRequired,
	username: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	projeto: PropTypes.object,
	grupos: PropTypes.object,
	redirect: PropTypes.func.isRequired,
	deleteUser: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/ManageUser/UsuarioItem.js